import { ReactElement } from 'react';
import { Button, ButtonProps } from '@mui/material';

import { useStyles } from './useStyles';

export function ConnectButton({ ...props }: ButtonProps): ReactElement {
  const { classes, cx } = useStyles();

  return (
    <Button
      color="info"
      size="large"
      type="button"
      variant="outlined"
      {...props}
      className={cx(classes.root, props.className)}
    />
  );
}
